import { Button } from "@design-system/shadcn";
import { ArrowUpDown, ChevronDown, ChevronUp } from "lucide-react";
import React from "react";

import type { SortOrder } from "../schemas";

const SORT_INDICATOR = {
  asc: <ChevronUp className="ml-2 h-4 w-4" />,
  desc: <ChevronDown className="ml-2 h-4 w-4" />,
  none: <ArrowUpDown className="ml-2 h-4 w-4" />,
} as const;

interface SortableHeaderProps {
  children: React.ReactNode;
  canSort: boolean;
  sortDirection: false | SortOrder;
  onSort: () => void;
}

function SortableHeader({
  children,
  canSort,
  sortDirection,
  onSort,
}: SortableHeaderProps) {
  if (!canSort) {
    return <span>{children}</span>;
  }

  return (
    <Button
      // Not `ghost`: it hovers to the same token the header row paints, so on a
      // hovered row the pill would show nothing extra under the pointer.
      variant="ghost-emphasised"
      onClick={onSort}
      // `-ml-2` cancels `px-2`, so the label lines up with plain header text in
      // `TableHead`'s own `px-2`; the max width is the cell's border box after that
      // shift, so a long label is clipped instead of painting over the next header.
      className="-ml-2 h-8 max-w-[calc(100%+0.5rem)] px-2 text-left font-medium"
    >
      <span className="min-w-0 truncate">{children}</span>
      {SORT_INDICATOR[sortDirection === false ? "none" : sortDirection]}
    </Button>
  );
}

export { SortableHeader };
export type { SortableHeaderProps };
